'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Constants = require('../../Constants');

var _IconConstants = require('UIComponents/icon/IconConstants');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGTextIconStyle = require('./SVGTextIconStyle');

var _SVGTextIconStyle2 = _interopRequireDefault(_SVGTextIconStyle);

var _SVGWrapper = require('./SVGWrapper');

var _SVGWrapper2 = _interopRequireDefault(_SVGWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AVATAR_RESPONSIVE_CENTER = 10;
var AVATAR_ICON_LARGEST_SIZE = _Constants.AVATAR_SIZES['xl'];
var AVATAR_CENTER_MULTIPLYER = AVATAR_RESPONSIVE_CENTER / AVATAR_ICON_LARGEST_SIZE;
var AVATAR_TEXT_MULTIPLIER = 0.37;

var SVGIconEdit = function SVGIconEdit(_ref) {
  var wrapperProps = _ref.wrapperProps,
      size = _ref.size;

  var avatar_y = size ? size * AVATAR_CENTER_MULTIPLYER : AVATAR_RESPONSIVE_CENTER;
  var icon_size = size * AVATAR_TEXT_MULTIPLIER;
  var avatar_style = size ? {
    fontSize: icon_size + 'px',
    fontWeight: '' + (icon_size > _IconConstants.ICON_SIZES.medium ? 'bold' : 'normal')
  } : {};

  var SVGIconEditStyle = Object.assign({}, avatar_style);
  SVGIconEditStyle.fontSize = size * (AVATAR_TEXT_MULTIPLIER / 1.25) + 'px';

  return _react2.default.createElement(
    _SVGWrapper2.default,
    _extends({ className: 'overlay-content' }, wrapperProps),
    _react2.default.createElement(
      _SVGTextIconStyle2.default,
      { x: 0, y: avatar_y, style: avatar_style },
      'edit'
    )
  );
};

SVGIconEdit.propTypes = {
  size: _react.PropTypes.number.isRequired,
  wrapperProps: _react.PropTypes.object.isRequired
};

exports.default = SVGIconEdit;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.493/js/UIAvatarDisplay/baseStyledComponents/SVGIconEdit.js
// module id = 1002
// module chunks = 2 3